/**
 * The two Google scopes Omina asks for, in one place.
 *
 * They live in core because both sides now name them and they must not drift.
 * The Worker checks a stored grant against these strings
 * (`apps/api/src/lib/google.ts`), and the browser asks for them by name when
 * she chooses to connect — so a typo in one copy produces a grant that looks
 * fine on the consent screen and reads as "not permitted" forever afterwards,
 * with nothing anywhere saying why.
 *
 * They are **not** on the Google provider in `apps/api/src/auth.ts`. Signing in
 * asks only for identity; these are added per call by whoever is connecting.
 * That is what makes "skip for now" possible without a second consent trip for
 * the founder who does connect: better-auth appends a request's `scopes` to
 * the provider's, so one screen still covers everything she said yes to.
 *
 * Read-only on purpose. Omina never writes to a calendar and never sends
 * through Gmail (follow-up is draft-and-copy or our own outbound), so a write
 * scope would be asking for authority the product does not use.
 */

export const GOOGLE_CALENDAR_SCOPE = "https://www.googleapis.com/auth/calendar.readonly";
export const GOOGLE_GMAIL_SCOPE = "https://www.googleapis.com/auth/gmail.readonly";

/** What "connect my calendar and mail" means, as a request. */
export const GOOGLE_INTEGRATION_SCOPES: readonly string[] = [
  GOOGLE_CALENDAR_SCOPE,
  GOOGLE_GMAIL_SCOPE,
];
